function appendChildAtIndex(parent: Node, element: Node, index: number): void {
    if (index >= parent.childNodes.length) {
        parent.appendChild(element);
    } else {
        parent.insertBefore(element, parent.childNodes[index]);
    }
}

// ----------------------------------------------------------------------------

export default appendChildAtIndex;
